// WARNING
// This component has been deprecated in favor of <sdx-tag></sdx-tag>.
// Do not make change in this file - it only exists for backwards compatibility.

:host {
  display: block;
  position: relative;
}

.component {
  display: flex;
  justify-content: center;
  height: 100%;

  > .slot {
    width: 100%;
  }
}

.sales,
.hint,
.topic-dark,
.topic-light {
  > .ribbon-container {
    position: absolute;
    @include font-plain;
    @include text-small;
    line-height: $baseline-3;
    top: calc(#{$baseline-3} / 100 * -1 * 55); // overlap 55% to the top
    z-index: 1; // overlap the checkbox container
    padding: 0 $baseline-3;
    border-radius: 5px;
    color: $color-white;
  }
}

.sales {
  > .ribbon-container {
    background-color: $color-orchid;
  }
}

.hint {
  > .ribbon-container {
    background-color: $color-turquoise--active;
  }
}

.topic-dark {
  > .ribbon-container {
    background-color: $color-navy;
  }
}

.topic-light {
  > .ribbon-container {
    color: $color-navy;
    border: 1px solid $color-navy;
    background-color: $color-white;
  }
}

.sales.sdx--dark-theme {
  > .ribbon-container {
    background-color: $color-orchid-dark-theme;
  }
}

.hint.sdx--dark-theme {
  > .ribbon-container {
    background-color: $color-turquoise-dark-theme;
  }
}

.topic-dark.sdx--dark-theme {
  > .ribbon-container {
    background-color: $color-azure-dark-theme;
  }
}

.topic-light.sdx--dark-theme {
  > .ribbon-container {
    color: $color-gray-dark-theme;
    border: 1px solid $color-gray-dark-theme;
    background-color: $color-dusk-dark-theme;
  }
}

// --- deprecated ---

.loop {
  > .ribbon-container {
    position: absolute;
    overflow: hidden;
    top: -5px;

    .content {
      color: $color-white;
      background-color: $color-orchid;
      text-align: center;
      position: absolute;
      width: calc(100% * 1.414); /* 100% * sqrt(2) - pythagoras */
      -webkit-transform-origin: bottom left;
      -moz-transform-origin: bottom left;
      -ms-transform-origin: bottom left;
      -o-transform-origin: bottom left;
      transform-origin: bottom left;

      &::before,
      &::after {
        content: "";
        position: absolute;
        bottom: -$ribbon-corner-size;
        border-left: $ribbon-corner-size solid transparent;
        border-right: $ribbon-corner-size solid transparent;
        border-top: $ribbon-corner-size solid $color-orchid--active;
      }

      &::before {
        left: 0;
      }

      &::after {
        right: 0;
      }
    }
  }
}

.small {
  > .slot {
    min-height: $ribbon-small-dimension;
  }
}

.normal {
  > .slot {
    min-height: $ribbon-regular-dimension;
  }
}

.large {
  > .slot {
    min-height: $ribbon-large-dimension;
  }
}

.loop.small {
  > .ribbon-container {
    font-size: $ribbon-font-small;
    width: $ribbon-small-dimension;
    height: $ribbon-small-dimension;
  }
}

.loop.normal {
  > .ribbon-container {
    font-size: $ribbon-font-normal;
    width: $ribbon-regular-dimension;
    height: $ribbon-regular-dimension;
  }
}

.loop.large {
  > .ribbon-container {
    font-size: $ribbon-font-large;
    width: $ribbon-large-dimension;
    height: $ribbon-large-dimension;
  }
}

.loop.left {
  > .ribbon-container {
    left: -5px;

    .content {
      -webkit-transform: rotate(-45deg);
      -moz-transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      -o-transform: rotate(-45deg);
      transform: rotate(-45deg);
      bottom: 0;
    }
  }
}

.loop.right {
  > .ribbon-container {
    right: -5px;

    .content {
      top: -24px; /* 24px lineheight */
      -webkit-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
}

.bookmark {
  > .ribbon-container {
    position: absolute;
    top: 6px;
    min-width: 70px;
    background-color: $color-turquoise;
    color: $color-white;

    &::after {
      content: "";
      position: absolute;
      bottom: -$ribbon-badge-corner-size;
      border-top: $ribbon-badge-corner-size solid $color-turquoise--active;
    }
  }
}

.bookmark.right {
  > .ribbon-container {
    right: -$ribbon-badge-corner-size;

    &::after {
      right: 0;
      border-right: $ribbon-badge-corner-size solid transparent;
    }
  }
}

.bookmark.left {
  > .ribbon-container {
    left: -$ribbon-badge-corner-size;

    &::after {
      left: 0;
      border-left: $ribbon-badge-corner-size solid transparent;
    }
  }
}

.bookmark.small {
  > .ribbon-container {
    font-size: $ribbon-font-small;
    padding: $ribbon-badge-padding-v-small $ribbon-badge-padding-h
      $ribbon-badge-padding-v-small;
  }
}

.bookmark.normal {
  > .ribbon-container {
    font-size: $ribbon-font-normal;
    padding: $ribbon-badge-padding-v $ribbon-badge-padding-h
      $ribbon-badge-padding-v;
  }
}

.bookmark.large {
  > .ribbon-container {
    font-size: $ribbon-font-large;
    padding: $ribbon-badge-padding-v-large $ribbon-badge-padding-h
      $ribbon-badge-padding-v-large;
  }
}
